/* step one of mobile verification, entering a number */
<template>
  <div v-if="!getLoadingBoolean">
    <h2>{{ $t('message.common.mobileVerification.title') }}</h2>
    <p>{{ $t('message.trade.mobileVerification.text') }}</p>
    <mobialis-form-with-validation
      @onValidate="continueForm"
      v-av-analytics-form-submit="{ elementText: $t('message.common.mobileVerification.sendCode') }"
    >
      <mobialis-text-input-with-validation
        class="col-12 col-sm-7 pl-0"
        rules="required|length:10"
        :label="$t('message.common.mobileVerification.labelTitle')"
        v-model="phoneNumber"
        vid="phoneNumber"
        placeholder="(   )"
        mask-type="phoneNumber"
        type="tel"
        data-cy="phoneNumber"
      ></mobialis-text-input-with-validation>
      <mobialis-button type="submit" class="verifyButton" data-cy="verifyNumber">{{
        $t('message.common.mobileVerification.sendCode')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';

export default {
  name: 'Mobile',
  data() {
    return {};
  },
  mounted() {
    this.$store.commit('SET_LOADING', false);
  },
  computed: {
    ...mapGetters({ leadId: 'lead/getLeadId' }),
    ...mapGetters(['getLoadingBoolean']),
    phoneNumber: {
      get() {
        return this.$store.state.user.phoneNumber;
      },
      set(value) {
        this.$store.commit('user/SET_PHONE_NUMBER', value);
      },
    },
  },

  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('user/sendVerificationCode', this.leadId);
        this.$router.push({ path: `${this.getProductBasePath()}/verification-code` });
      } catch (error) {
        log('Error in sending verification code! [trade]', error);
        this.$router.push({ path: `${this.getProductBasePath()}/error` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 350px) {
  div {
    .inputContainer {
      width: 100%;
    }
  }
}
.inputContainer {
  width: 50%;
}

h2 {
  font-size: 22px;
  font-weight: bold;
}
.verifyButton {
  margin-top: 285px;
}
</style>
